import { Theme } from '@mui/material/styles';

export default function Pickers(theme: Theme): unknown {
  return {
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          maxHeight: 360,
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: `${theme.palette.background.yaleBlue} !important`,
            '&:hover': {
              backgroundColor: `${theme.palette.background.yaleBlue} !important`,
            },
          },
        },
      },
    },
  };
}
